import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseComponent } from "../../../base.component";
import { takeUntil } from "rxjs/operators";
import { distinctUntilChanged } from "rxjs";

@Component({
    selector: 'lex-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextInputComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class TextInputComponent extends BaseComponent implements OnInit, ControlValueAccessor {
	@Input() label: string;
	@Input() placeholder: string = '';
	@Input() type: 'input' | 'textarea' | 'search' = 'input';
	@Input() autocomplete: 'on' | 'off' = 'on';
	@Input() rows: number = 3;
	@Input() autoSizeTextarea: boolean = false;
	@Input() formControl: any;
	@Input() disabled: boolean = false;
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public _onChange = (value) => {
		// Intentionally Empty
	};
	public _onTouched = () => {
		// Intentionally Empty
	};

	public id: string;

	constructor() {
		super();
		this.id = `input-field-${this.getRandomNumber()}`;
	}

	public ngOnInit(): void {
		if (!this.formControl) {
			this.formControl = new FormControl<string>('');
		}
		this.formControl.valueChanges.pipe(
			distinctUntilChanged(),
			takeUntil((this.destroy$))
		).subscribe((v) => {
			this._onChange(v);
		});
	}

	public writeValue(value: any): void {
		if (this.formControl.value !== value) {
			this.formControl.setValue(value, { emit: false });
		}
	}

	public registerOnChange(fn: any): void {
		this._onChange = fn;
	}

	public registerOnTouched(fn: any): void {
		this._onTouched = fn;
	}

	public onInputChange(value: any) {
		this._onChange(value);
	}

	private getRandomNumber(): string {
		const randomNumber = Math.floor(Math.random() * 10000) + 1;
		return randomNumber.toString().padStart(5, '0');
	}
}
